import { CUSTOMER_SOURCE_HEADERS_KEY } from '../customerSourceStorage';

const WEB2APP_GC_PENDING_KEY = 'web2app_gc_pending';
const WEB2APP_CAMPAIGN_PREFIX = 'web2app';

function isWeb2AppCampaign(value: string | null | undefined): boolean {
  return value?.toLowerCase().startsWith(WEB2APP_CAMPAIGN_PREFIX) ?? false;
}

function getStoredUtmCampaign(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(CUSTOMER_SOURCE_HEADERS_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as {
      headers?: Record<string, string>;
      ['x-utm-campaign']?: string;
    };

    if (parsed.headers?.['x-utm-campaign']) {
      return parsed.headers['x-utm-campaign'];
    }

    return parsed['x-utm-campaign'] ?? null;
  } catch {
    return null;
  }
}

export function isWeb2AppAttributionFlow(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const urlCampaign = new URL(window.location.href).searchParams.get('utm_campaign');
  if (isWeb2AppCampaign(urlCampaign)) {
    return true;
  }

  return isWeb2AppCampaign(getStoredUtmCampaign());
}

export function markWeb2AppGcPending(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(WEB2APP_GC_PENDING_KEY, '1');
}

export function consumeWeb2AppGcPending(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const isPending = window.localStorage.getItem(WEB2APP_GC_PENDING_KEY) === '1';
  if (isPending) {
    window.localStorage.removeItem(WEB2APP_GC_PENDING_KEY);
  }
  return isPending;
}
